import { AsyncPipe, NgIf } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { CmsArea } from '@domgen/dgx-fe-cms';
import { fadeInOut } from '@domgen/dgx-fe-components/animation';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';
import { GA_CONFIG } from '@domgen/dgx-fe-ga';
import { SeoPage } from '@domgen/dgx-fe-seo';
import { EditableArea } from '@magnolia/angular-editor';
import { ApplianceDetailsSteppedBenefitsPanelComponent } from '../../components/appliance-details-stepped-benefits-panel/appliance-details-stepped-benefits-panel.component';
import { ApplianceDetailsSteppedFormComponent } from '../../components/appliance-details-stepped-form/appliance-details-stepped-form.component';
import { ApplianceDetailsSteppedComponentService } from '../../services/appliance-details-stepped-component/appliance-details-stepped-component.service';

@Component({
  templateUrl: './appliance-details-stepped.component.html',
  styleUrls: ['./appliance-details-stepped.component.scss'],
  providers: [ApplianceDetailsSteppedComponentService],
  animations: [fadeInOut],
  standalone: true,
  imports: [
    ApplianceDetailsSteppedBenefitsPanelComponent,
    ApplianceDetailsSteppedFormComponent,
    AsyncPipe,
    EditableArea,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    GridSectionComponent,
    NgIf,
  ],
})
@SeoPage()
export class ApplianceDetailsSteppedComponent {
  @Input() banner!: CmsArea;
  @Input() main!: CmsArea;

  canadaUrl = 'https://whirlpool.registria.com/en-ca/pr_reg';

  constructor(readonly cs: ApplianceDetailsSteppedComponentService) {
    const domainId = inject(GA_CONFIG).domainId;
    this.canadaUrl = `https://${domainId}.registria.com/en-ca/pr_reg`;
  }
}
